export enum FeatureFlagNames {
  balancingMarketEnabled = 'Feature:BalancingMarketEnabled',
  dayAheadMarketEnabled = 'Feature:DayAheadMarketEnabled',
  monthlyForwardMarketEnabled = 'Feature:MonthlyForwardMarketEnabled',
  weeklyForwardMarketEnabled = 'Feature:WeeklyForwardMarketEnabled',
  intraDayMarketEnabled = 'Feature:IntraDayMarketEnabled',
  operationalReportingEnabled = 'Feature:OperationalReportingEnabled',
  marketSurveillanceEnabled = 'Feature:MarketSurveillanceEnabled',
  bulkDownloadEnabled = 'Feature:BulkDownloadEnabled',
  meterDataIntegrationEnabled = 'Feature:MeterDataIntegrationEnabled',
  customerPortalEnabled = 'Feature:CustomerPortalEnabled',
  energySchedulingEnabled = 'Feature:EnergySchedulingEnabled',
  planningEnabled = 'Feature:PlanningEnabled',
  mediumTermPlanningEnabled = 'Feature:MediumTermPlanningEnabled',
  mediumTermPlanningSupplyOptionLossesEnabled = 'Feature:MediumTermPlanningSupplyOptionLossesEnabled',
  shortTermPlanningEnabled = 'Feature:ShortTermPlanningEnabled',
  capacityPlanningEnabled = 'Feature:CapacityPlanningEnabled',
  energySettlementEnabled = 'Feature:EnergySettlementEnabled',
  financialSettlementEnabled = 'Feature:FinancialSettlementEnabled',
  etsMtpIntegrationEnabled = 'Feature:EtsMtpIntegrationEnabled',
  txAllocationManagementEnabled = 'Feature:TxAllocationManagementEnabled',
  scadaIntegrationEnabled = 'Feature:ScadaIntegrationEnabled',
  settlementDashboardEnabled = 'Feature:SettlementDashboardEnabled',
  touDashboardEnabled = 'Feature:TimeOfUseDashboardEnabled',
  timeOfUseManagementEnabled = 'Feature:TimeOfUseManagementEnabled',
  powerTradingDashboardEnabled = 'Feature:PowerTradingDashboardEnabled',
  zambianMarketDashboardEnabled = 'Feature:ZambianMarketDashboardEnabled',
  meterAvailabilityReportEnabled = 'Feature:MeterAvailabilityReportEnabled',
  touReportEnabled = 'Feature:TimeOfUseReportEnabled',
  multiCurrencyEnabled = 'Feature:MultiCurrencyEnabled',
  currencyEnabled = 'Feature:CurrencyEnabled',
  dealCaptureEnabled = 'Feature:DealCaptureEnabled',
  dealCaptureManageSettlementsEnabled = 'Feature:DealCaptureManageSettlementsEnabled',
  settlementTariffEnabled = 'Feature:SettlementTariffEnabled',
  settlementsDashboardEnabled = 'Feature:SettlementsDashboardEnabled',
  cecUserAccessDashboardEnabled = 'Feature:CecUserAccessDashboardEnabled',
  cecMeterDataDashboardEnabled = 'Feature:CecMeterDataDashboardEnabled',
  cecSchedulingDataDashboardEnabled = 'Feature:CecSchedulingDataDashboardEnabled',
  cecPlanningOptimisationDashboardEnabled = 'Feature:CecPlanningOptimisationDashboardEnabled',
  energyAllocationOptimizationEnabled = 'Feature:EnergyAllocationOptimizationEnabled',
  manualMeterConsumption = 'Feature:ManualMeterConsumption',
  shortTermPlanningDemandForecastEnabled = 'Feature:ShortTermPlanningDemandForecastEnabled',
  rulesEnabled = 'Feature:DataProcessing:RulesEnabled',
  energyAllocationForecastEnabled = 'Feature:ForecastAllocationOptimisationEnabled',
}
